/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: Editor.ts
 * Project: mle-client
 * Committed last: 2021/10/25 @ 1138
 * ---
 */

import styled from 'styled-components';

export const MlEditorLayout = {
  Root: styled.div`
    height: 100vh;
    margin: 0;
  `,
  Wrapper: styled.div`
    display: flex;
    flex-flow: column;
    height: 100%;
  `,
  Header: styled.div`
    flex: 0 1 auto;
  `,
  Content: styled.div`
    display: flex;
    flex-flow: row;
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: auto;
    justify-content: space-between;
    justify-items: center;
  `,
  Footer: styled.div`
    flex: 0 1 auto;
  `
};
